import { defineComponent as _defineComponent } from 'vue'
import { ref, shallowRef } from "vue"
import { VueEditor } from "vue2-editor"

type Props = {
  value?: string
  id?: string
}
type Emits = {
  (e: "update:modelValue" | "change" | "input", value: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorHtml',
  props: {
    value: null,
    id: { default: "textEditor" }
  },
  emits: ["update:modelValue", "change", "input"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "update:modelValue" | "change" | "input", value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string, id: string };




const editorRef = ref()
const content = shallowRef(props.value || "")

const updateValue = () => {
  let html = editorRef.value.quill.getHTML()

  emit("change", html)
  emit("input", html)
  emit("update:modelValue", html)
}

const toolbarOptions = {
  modules: {
    toolbar: {
      container: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"]
      ]
    }
  }
}

const setNewContent = (text: string) => {
  content.value = text
}
const getText = () => {
  editorRef.value.quill.getText()
}

expose({
  setNewContent,
  getText
})

return { __sfc: true,props, emit, editorRef, content, updateValue, toolbarOptions, setNewContent, getText, VueEditor }
}

})